import { Component } from 'react';
import NavigationTabLinks from '../containers/navigationTabLinks';

class NavigationTabLinksForSettlements extends Component {
    render() {
        return (
            <NavigationTabLinks
                items={[
                    { to: '/pdfsett/daily', icon: 'fe fe-credit-card', label: `pages.settlementsByDay.title`, tooltip: `pages.settlementsByDay.titleTooltip` },
                    { to: '/pdfsett/monthly', icon: 'fe fe-calendar', label: `pages.settlementsByMonth.title`, tooltip: `pages.settlementsByMonth.titleTooltip` },
                    { to: '/pdfsett/charge-backs', icon: 'fe fe-settings', label: `pages.settlementChargeBacks.title`, tooltip: `pages.settlementChargeBacks.titleTooltip` }
                ]} 
            ></NavigationTabLinks>
        )
    };
}

export default NavigationTabLinksForSettlements;